import { ReservationSummary } from '@mews-commander/guest-profile';
import { LocalizedDateFromUtc, LocalizedShortTimeFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { ItemLabel } from '../../common';
import { useTimeUnitKey } from '../hooks';

const DateTime = ({ utcString }: { utcString: string }) => (
    <Stack>
        <LocalizedDateFromUtc utcString={utcString} />
        {UnicodeEntity.Comma}
        {UnicodeEntity.NoBreakSpace}
        <LocalizedShortTimeFromUtc utcString={utcString} />
    </Stack>
);

type ReservationContentProps = Omit<ReservationSummary, 'id' | 'number'>;

export const ReservationContent = ({
    accountState,
    endUtc,
    groupName,
    serviceId,
    startUtc,
}: ReservationContentProps) => {
    const { count, unitKey } = useTimeUnitKey({ endUtc, serviceId, startUtc }) || {};
    return (
        <Stack spacing="100" vertical>
            {accountState ? <ItemLabel label={lt('AccountMergeGuestDetailReservation')} value={accountState} /> : null}
            {groupName ? <ItemLabel label={lt('Group')} value={groupName} /> : null}
            <ItemLabel label={lt('CheckIn')} value={<DateTime utcString={startUtc} />} />
            <ItemLabel label={lt('CheckOut')} value={<DateTime utcString={endUtc} />} />
            {unitKey ? <ItemLabel label={lt(unitKey)} value={count} /> : null}
        </Stack>
    );
};
